import { render, staticRenderFns } from "./KpiSettingNew.vue?vue&type=template&id=0bb09812"
import script from "./KpiSettingNew.vue?vue&type=script&lang=js"
export * from "./KpiSettingNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports